module.exports = __webpack_public_path__ + "img/reimpulso.e7aa817f.png";